var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2933_36238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4211 0H7.57895C3.39321 0 0 3.39321 0 7.57895V40.4211C0 44.6068 3.39321 48 7.57895 48H40.4211C44.6068 48 48 44.6068 48 40.4211V7.57895C48 3.39321 44.6068 0 40.4211 0Z",
    fill: "#2F855A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.421 0C44.6084 0 47.9999 3.39158 47.9999 7.57895V26.5263C33.3473 26.5263 21.4736 14.6526 21.4736 0H40.421Z",
    fill: "#9AE6B4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 29.0526H16.4211C17.8168 29.0526 18.9474 30.1832 18.9474 31.579V48H7.57895C3.39158 48 0 44.6084 0 40.4211V29.0526Z",
    fill: "#9AE6B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2933_36238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlan);
export default __webpack_public_path__ + "static/media/FreePlan.278ebe304e5f69dd75fb2216af756083.svg";
export { ForwardRef as ReactComponent };